"use strict";

var _taggedTemplateLiteral = require("/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderDetailFragment = exports.orderPriceFragment = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var checkout_1 = require("./checkout");

exports.orderPriceFragment = graphql_tag_1.default(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment OrderPrice on TaxedMoney {\n    gross {\n      amount\n      currency\n    }\n    net {\n      amount\n      currency\n    }\n  }\n"])));
exports.orderDetailFragment = graphql_tag_1.default(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  fragment OrderDetail on Order {\n    userEmail\n    paymentStatus\n    paymentStatusDisplay\n    status\n    statusDisplay\n    id\n    token\n    number\n    shippingAddress {\n      ...Address\n    }\n    lines {\n      productName\n      quantity\n      variant {\n        ...ProductVariant\n      }\n      unitPrice {\n        currency\n        ...OrderPrice\n      }\n      totalPrice {\n        currency\n        ...OrderPrice\n      }\n    }\n    subtotal {\n      ...OrderPrice\n    }\n    total {\n      ...OrderPrice\n    }\n    shippingPrice {\n      ...OrderPrice\n    }\n  }\n"])), exports.orderPriceFragment, checkout_1.checkoutAddressFragment, checkout_1.checkoutProductVariantFragment);